<div class="body">
  <!--  <div class="bg1 store w-clearfix"><a class="logo w-inline-block"></a>


      <div>
        <div class="div-block-5 store">
          <h1 data-w-id="5b1824a1-e9b7-e678-7109-cfbf31b59495" class="heading-15 storee"><br></h1>

        </div>
      </div>
      <div class="div-block store">
        <div class="row-9 w-row">
          <div class="column-3 w-col w-col-1 w-col-small-1 w-col-tiny-1"></div>
          <div class="column w-col w-col-9 w-col-small-9 w-col-tiny-9">
            <p class="paragraph _1">Daily essentials delivered at your doorstep! </p>
          </div>
          <div class="column-2 w-col w-col-2 w-col-small-2 w-col-tiny-2"><img src="/assets/images/V0J6a.gif" width="100" class="image-30"></div>
        </div>
      </div>
    </div>-->


    <ngb-carousel class="hidden-sm-down" style="width:100% !important; margin: 15px 0px 0px 0px; box-shadow: 0px 0px;">
      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/webassets/sliders/storeslide1.jpg">

      </ng-template>
      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/webassets/sliders/storeslide2.jpg">

      </ng-template>
      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/webassets/sliders/storeslide3.jpg">

      </ng-template>

    </ngb-carousel>


    <ngb-carousel class="hidden-md-up" style="width:100% !important; margin: 15px 0px 0px 0px; box-shadow: 0px 0px;">
      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/mobassets/sliders/storeslide1.jpg">

      </ng-template>
      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/mobassets/sliders/storeslide2.jpg">

      </ng-template>
      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/mobassets/sliders/storeslide3.jpg">

      </ng-template>

      <ng-template ngbSlide>
        <img class="slidepc" src="https://petcart.in/mobassets/sliders/storeslide4.jpg">

      </ng-template>

    </ngb-carousel>


    <div class="hidden-md-up">
              <img src="https://petcart.in/mobassets/sliders/shopbypet.jpg">
              <div class="row" style="margin:0px; width:100%; text-align: center; background: #fff;">
                <div class="shopnewbtn" (click)="goToProductCategory(1, 'Dog')" style="width:32%;">
                 <img  class="shopnewbtnimg" src="https://petcart.in/mobassets/ico/dogicon.png" style="height: 70px;">
                   <br>Dog
                </div>


                <div class="shopnewbtn" (click)="goToProductCategory(2, 'Cat')" style="width:32%">
                 <img class="shopnewbtnimg" src="https://petcart.in/mobassets/ico/caticon.png" style="height: 70px;">
                   <br>Cat
                </div>

                <div class="shopnewbtn" (click)="goToProductCategory(3, 'Bird')" style="width:32%">
                 <img class="shopnewbtnimg" src="https://petcart.in/mobassets/ico/birdicon.png" style="height: 70px;">
                  <br>Bird
                </div>
                  </div>
      </div>







    <div class="bg2">

      <div class="div-block-20 hidden-sm-down">
        <h1 class="heading-6 store">Top Rated Brands</h1>
      </div>
      <div class="div-block-38 hidden-sm-down">
        <div  class="slider store w-slider">
          <div class="mask w-slider-mask" id="scroller">

            <div class="slide store w-slide" (click)="gotoSearchByBrand(81)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//p/e/pedigree-chicken-_-veg-10kg_1.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Pedigree</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(1)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//l/a/labrador-retriever-adult_3.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Royal Canin</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(10)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//a/r/arden_grange_adult_prestige_12_kgs.png" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Arden Grange</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(114)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//3/k/3kg_1.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Whiskas</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(70)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//m/e/meo_persian_adult_7_kg.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Me-O</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(96)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//s/h/sheba_deluxe_tune_white_meat_snapper_in_gravy_-_85g.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Sheba</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(98)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//s/m/smart_heart_chicken_and_egg_flavour_2.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Smart Heart</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(24)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//c/a/cat_o_best_20_litres.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Cat's Best</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(41)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//d/r/drools_adult_chicken___egg_3.png" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Drools</h5>
                 </span>
              </div>
            </div>

            <div class="slide store w-slide" (click)="gotoSearchByBrand(64)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//j/e/jerhigh_liver.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Jerhigh</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(18)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//b/2/b25-med.png" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">BI</h5>
                 </span>
              </div>
            </div>
            <div class="slide store w-slide" (click)="gotoSearchByBrand(59)">
              <div class="div-block-22"><img src="https://passport.petcart.in/images/prodimgs//i/d/id_1.jpg" class="image-10"></div>
              <div class="div-block-400">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:1rem; padding-top:10px;">Science Plan</h5>
                 </span>
              </div>
            </div>

          </div>
          <div class="left-arrow w-slider-arrow-left" style="margin-top: -35px !important" >
            <div class="icon-3 w-icon-slider-left" (click)="scrollDiv('l', 130)" ></div>
          </div>
          <div class="right-arrow w-slider-arrow-right" style="margin-top: -35px !important">
            <div class="icon-2 w-icon-slider-right" (click)="scrollDiv('r', 130)"></div>
          </div>
          <div class="slide-nav w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-nav w-slider-nav-invert w-round"></div>
        </div>
     <!--   <div class="div-block-39"><a (click)="gotoSearchByAll()" class="button-6 w-button">Shop all</a></div>-->
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <div class="div-block-20">
            <h1 class="heading-6 store">Customer Favourites</h1>
          </div>
        </div>
      </div>


      <div class="div-block-38 hidden-sm-down">
          <div class="slider store w-slider incheight">
              <div class="mask w-slider-mask" id="scroller1">

              <div class="slide store w-slide" routerLink="/store/products/15/dog-dry-food.html">
                <div class="div-block-21p"> <img src="https://petcart.in/mobassets/Dryfood.jpg" class="image-24"></div>
                <div class="div-block-40p">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:1rem;">Dog Dry Food</h5>
                  </span>
                </div>
              </div>
              <div class="slide store w-slide" routerLink="/store/products/31/cat-dry-food.html">
                <div class="div-block-21p"> <img src="https://petcart.in/mobassets/dryfoodcat.jpg" class="image-24"></div>
                <div class="div-block-40p">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:1rem;">Cat Dry Food</h5>
                  </span>
                </div>
              </div>
              <div class="slide store w-slide" routerLink="/store/products/16/dog-wet-food.html">
                <div class="div-block-21p"> <img src="https://petcart.in/mobassets/wetfood.jpg" class="image-24"></div>
                <div class="div-block-40p">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:1rem;">Dog Wet Food</h5>
                  </span>
                </div>
              </div>
              <div class="slide store w-slide" routerLink="/store/products/32/cat-wet-food.html">
                <div class="div-block-21p"> <img src="https://petcart.in/mobassets/wetfoodcat.jpg" class="image-24"></div>
                <div class="div-block-40p">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:1rem;">Cat Wet Food</h5>
                  </span>
                </div>
              </div>
              <div class="slide store w-slide" routerLink="/store/products/6/dog-treats.html">
                <div class="div-block-21p"> <img src="https://petcart.in/mobassets/treats.jpg" class="image-24"></div>
                <div class="div-block-40p">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:1rem;">Dog Treats</h5>
                  </span>
                </div>
              </div>
              <div class="slide store w-slide" routerLink="/store/products/38/litter.html">
                <div class="div-block-21p"> <img src="https://petcart.in/mobassets/litter.jpg" class="image-24"></div>
                <div class="div-block-40p">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:1rem;">Cat Litter</h5>
                  </span>
                </div>
              </div>

          </div>
          <div class="left-arrow w-slider-arrow-left" style="margin-top:-10px !important">
              <div class="icon-3 w-icon-slider-left" (click)="scrollDiv1('l', 130)"></div>
            </div>
            <div class="right-arrow w-slider-arrow-right" style="margin-top:-10px !important">
              <div class="icon-2 w-icon-slider-right"  (click)="scrollDiv1('r', 130)"></div>
            </div>
        </div>
      </div>


  <div class="hidden-md-up">
      <div class="row" style="text-align: center;     margin-left: 0px;">

                       <div class="shopnewbtn"(click)="goToProductListWithCategory(15, 'dog-dry-food.html')"
                       style="border:#dbd3be 1px solid; width:32%;padding: 10px;">
                         <img  class="shopnewbtnimg" src="https://petcart.in/mobassets/Dryfood.jpg">
                           <br>Dog Dry Food

                       </div>
                       <div class="shopnewbtn"(click)="goToProductListWithCategory(31, 'cat-dry-food.html')"
                       style="border:#dbd3be 1px solid; width:32%;padding: 10px;">

                         <img class="shopnewbtnimg" src="https://petcart.in/mobassets/dryfoodcat.jpg">
                           <br>Cat Dry Food
                       </div>
                       <div class="shopnewbtn" (click)="goToProductListWithCategory(16, 'dog-wet-food.html')"
                       style="border:#dbd3be 1px solid; width:32%;padding: 10px;">

                         <img class="shopnewbtnimg" src="https://petcart.in/mobassets/wetfood.jpg">
                          <br>Dog Wet Food
                       </div>
                     </div>

                          <div class="row" style="text-align: center;     margin-left: 0px;">
                                <div class="shopnewbtn"(click)="goToProductListWithCategory(32, 'cat-wet-food.html')"
                                style="border:#dbd3be 1px solid; width:32%;padding: 10px;">

                         <img  class="shopnewbtnimg" src="https://petcart.in/mobassets/wetfoodcat.jpg">
                           <br>Cat Wet Food
                         </div>

                        <div class="shopnewbtn"(click)="goToProductListWithCategory(6, 'dog-treats.html')"
                        style="border:#dbd3be 1px solid; width:32%;padding: 10px;">

                         <img class="shopnewbtnimg" src="https://petcart.in/mobassets/treats.jpg">
                           <br>Dog Treats
                        </div>
                        <div class="shopnewbtn"(click)="goToProductListWithCategory(38, 'litter.html')"
                        style="border:#dbd3be 1px solid; width:32%;padding: 10px;">

                         <img class="shopnewbtnimg" src="https://petcart.in/mobassets/litter.jpg">
                          <br>Cat Litter
                        </div>
                      </div>


                      </div>







      <div class="div-block-20">
        <h1 class="heading-6 store">New Products</h1>
      </div>
      <div class="div-block-38">
        <div  class="slider store w-slider"
        *ngIf="newproduct"  style="height: 375px;">
          <div class="mask w-slider-mask" id="scroller2">

            <div class="slide store w-slide" *ngFor="let data of newproduct" routerLink="/store/details/{{data.id}}/{{data.url}}">
              <div class="div-block-21"><img src="https://passport.petcart.in/images/prodimgs/{{data.image}}" class="image-24"></div>
              <div class="div-block-40">
                <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                   <h5 style="font-size:0.8rem; padding:0px;">{{data.name}}</h5>
                </span>

                <span style="font-style: open sans; color: #cb983f; font-size:14px;  font-weight:bold;
                overflow-wrap: break-word" *ngIf="data.splprice === 0; ">
                    Rs. {{ data.price }}
                </span>
                    <p style="font-style: open sans; color: #cb983f;
                    overflow-wrap: break-word; padding-right: 25px; font-size:13px" *ngIf="data.splprice > 0;">
                    <del style="color:#c5c5c5">Rs. {{ data.price }}</del>
                    <span style="font-size:14px; float:right; font-weight:bold;">Rs. {{ data.splprice }}</span></p>
              </div>
            </div>
          </div>

          <div class="left-arrow w-slider-arrow-left" style="margin-top: -10px !important">
            <div class="icon-3 w-icon-slider-left" (click)="scrollDiv2('l', 130)" ></div>
          </div>
          <div class="right-arrow w-slider-arrow-right" style="margin-top: -10px !important">
            <div class="icon-2 w-icon-slider-right" (click)="scrollDiv2('r', 130)" ></div>
          </div>
          <div class="slide-nav w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-nav w-slider-nav-invert w-round"></div>
        </div>
       <!-- <div class="div-block-39"><a (click)="gotoSearchByAll()" class="button-6 w-button">Shop all</a></div>-->
      </div>

      <div class="div-block-20">
          <h1 class="heading-6 store">Consumer Offers</h1>
        </div>
        <div class="div-block-38">
          <div  class="slider store w-slider"
          *ngIf="featureproduct"  style="height: 375px;">
            <div class="mask w-slider-mask" id="scroller3">

              <div class="slide store w-slide" *ngFor="let data of featureproduct" routerLink="/store/details/{{data.id}}/{{data.url}}">
                <div class="div-block-21"><img src="https://passport.petcart.in/images/prodimgs/{{data.image}}" class="image-24"></div>
                <div class="div-block-40">
                  <span style="font-style:open sans; color: #9b7544; text-align: center; overflow-wrap: break-word;">
                     <h5 style="font-size:0.8rem; padding:0px;">{{data.name}}</h5>
                  </span>

                  <span style="font-style: open sans; color: #cb983f; font-size:14px;  font-weight:bold;
                  overflow-wrap: break-word" *ngIf="data.splprice === 0; ">
                      Rs. {{ data.price }}
                  </span>
                      <p style="font-style: open sans; color: #cb983f;
                      overflow-wrap: break-word; padding-right: 25px; font-size:13px" *ngIf="data.splprice > 0;">
                      <del style="color:#c5c5c5">Rs. {{ data.price }}</del>
                      <span style="font-size:14px; float:right; font-weight:bold;">Rs. {{ data.splprice }}</span></p>
                </div>
              </div>
            </div>

            <div class="left-arrow w-slider-arrow-left" style="margin-top: -10px !important">
              <div class="icon-3 w-icon-slider-left" (click)="scrollDiv3('l', 130)"></div>
            </div>
            <div class="right-arrow w-slider-arrow-right" style="margin-top: -10px !important">
              <div class="icon-2 w-icon-slider-right" (click)="scrollDiv3('r', 130)"></div>
            </div>
            <div class="slide-nav w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-nav w-slider-nav-invert w-round"></div>
          </div>
        <!--  <div class="div-block-39"><a (click)="gotoSearchByAll()" class="button-6 w-button">Shop all</a></div>-->
        </div>

    </div>


    <div class="col-12">
      <div class="div-block-20"  style="    width: 100%;">
        <h1 class="heading-6 store" style="float:left">All Brands</h1>
      </div>
    </div>
      <div class="div-block-38" style="height: 180px;">
          <div  class="slider store w-slider"
          *ngIf="newproduct"  style="height: 375px;">
            <div class="mask w-slider-mask" id="scroller4" style="width:100%;">

<a title="" (click)="gotoSearchByBrand(1)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/royal-canin-logo.gif">
</a><a title=""  (click)="gotoSearchByBrand(81)">
<img style="padding-right:25px; padding-bottom:10px;" src="https://petcart.in/mobassets/04/Pedigree_logo.png">
</a><a title=""  (click)="gotoSearchByBrand(59)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/hills_scienceplan_logo.jpg">
</a><a title="" (click)="gotoSearchByBrand(41)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/drools.png">
</a><a title="" (click)="gotoSearchByBrand(10)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/arden.png">
</a><a title=""  (click)="gotoSearchByBrand(45)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/fidele.png">
</a><a title=""  (click)="gotoSearchByBrand(98)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/smartheart.png">
</a><a title=""  (click)="gotoSearchByBrand(96)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/sheba.png">
</a><a title=""  (click)="gotoSearchByBrand(49)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/whiskas.png">
</a><a title=""  (click)="gotoSearchByBrand(70)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/meo.jpg">
</a><a title=""   (click)="gotoSearchByBrand(20)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/Bio-Groom-Logo.jpg">
</a><a title="" (click)="gotoSearchByBrand(64)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/jerhigh2.jpg">
</a><a title=""  (click)="gotoSearchByBrand(105)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/trixie-logo.jpg">
</a><a title=""  (click)="gotoSearchByBrand(112)">
<img style="padding-right:25px;" src="https://petcart.in/mobassets/04/vitapol.jpg">
</a>
</div>
<div class="left-arrow w-slider-arrow-left" style="margin-top:-250px !important">
    <div class="icon-3 w-icon-slider-left" (click)="scrollDiv4('l', 130)"></div>
  </div>
  <div class="right-arrow w-slider-arrow-right" style="margin-top:-250px !important">
    <div class="icon-2 w-icon-slider-right" (click)="scrollDiv4('r', 130)"></div>
  </div>
  <div class="slide-nav w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-nav w-slider-nav-invert w-round"></div>
   </div>

</div>





    <div class="div-block-41">
      <div class="div-block-43 w-clearfix">
        <h1 class="heading-17">Puppy and Kitten Corner</h1>
        <p class="paragraph-6">Are you a new pet parent? <br>Got a new puppy / kitten home?<br>
Find everything you need for your new family member... <br></p><img src="/assets/images/puppy-kitten.png" width="320" srcset="/assets/images/puppy-kitten-p-500.png 500w, /assets/images/puppy-kitten.png 640w" sizes="(max-width: 479px) 100vw, (max-width: 767px) 220px, (max-width: 991px) 260px, 320px" class="image-31">
        <div class="div-block-48"><a routerLink="/store/puppycorner" class="button-7 puppy w-button">Puppy</a>
          <a  routerLink="/store/kittencorner" class="button-7 kitten w-button">Kitten</a></div>
      </div>
    </div>


    </div>
